var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExampleStory',[_c('TfTable',_vm._b({scopedSlots:_vm._u([{key:"parentRow",fn:function({ rowData }){return _c('TfTableParentRow',{key:rowData.id},[_vm._l((_vm.tableMeta.columns),function(column){return [(column.prop !== 'easterEgg')?_c('TfTableTd',{key:column.id,domProps:{"textContent":_vm._s(rowData[column.prop])}}):_vm._e()]})],2)}}])},'TfTable',{
      pageLimit: 25,
      pagination: true,
      showFilterLabel: true,
      tableData: [..._vm.table.data],
      tableMeta: _vm.tableMeta,
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }